import { createSlice } from '@reduxjs/toolkit';
import { getTopicList, submitRequest } from '../thunk/help-request-thunk';

// Initial state
const initialState = {
  topics: [],
  items: [],
  formRequest: {
    full_name: '',
    phone_number: '',
    email: '',
    reference: '',
    topic: '',
    message: '',
    contact_medium: 'Any',
    user_id: null,
  },
  isLoading: false,
  error: null,
  selectedTopic: '',
  isSuccess: false,
  isFailed: false,
  isTopicsLoaded: false,
  checkValidation: false,
  isChecking: false,
  errorFound: {
    full_name: 0,
    phone_number: 0,
    email: 0,
    reference: 0,
    topic: 0,
    message: 0,
  },
  canSubmit: false,
  errorCounter: 0,
};

// Slice
const helpRequestSlice = createSlice({
  name: 'help-request',
  initialState,
  reducers: {
    updateForm: (state, action) => {
      state.formRequest = action.payload;
    },
    resetHelpRequest: (state) => {
      state.formRequest = {
        full_name: '',
        phone_number: '',
        email: '',
        reference: '',
        topic: '',
        message: '',
        contact_medium: 'Any',
        user_id: null,
      };
      state.isSuccess = false;
      state.isFailed = false;
      state.error = false;
      state.isLoading = false;
      state.isTopicsLoaded = false;
      state.selectedTopic = '';
      state.canSubmit = false;
      state.errorFound = {
        full_name: 0,
        phone_number: 0,
        email: 0,
        reference: 0,
        topic: 0,
        message: 0,
      };
    },
    updateTopic: (state, action) => {
      state.selectedTopic = action.payload;
    },
    resetHelpRequestStatusModal: (state) => {
      state.isFailed = false;
      state.isSuccess = false;
    },
    checkValidationBeforeSubmit: (state) => {
      state.checkValidation = true;
      state.isChecking = true;
    },
    validationResult: (state, action) => {
      if (action.payload?.invalid) {
        state.errorFound = { ...state.errorFound, [action.payload.name]: 1 };
      }
      state.checkValidation = false;
      state.isChecking = false;
    },
    validatePass: (state, action) => {
      state.errorFound = { ...state.errorFound, [action.payload.name]: 0 };
    },
    submitAllowed: (state, action) => {
      state.canSubmit = true;
      state.checkValidation = false;
      state.error = null;
    },
    resetValidation: (state) => {
      state.errorFound = false;
      state.checkValidation = false;
    },
    resetError: (state) => {
      state.error = null;
    },
    resetSubmitOnError: (state) => {
      state.canSubmit = false;
      state.error = false;
      state.isFailed = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTopicList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTopicList.fulfilled, (state, action) => {
        state.topics = action.payload || [];
        state.isLoading = false;
        state.isTopicsLoaded = true;
      })
      .addCase(getTopicList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(submitRequest.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.isFailed = false;
        state.isSuccess = false;
      })
      .addCase(submitRequest.fulfilled, (state, action) => {
        state.items = action.payload || [];
        state.isLoading = false;
        state.isSuccess = true;
        state.isFailed = false;
      })
      .addCase(submitRequest.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.data;
        if (action.payload?.status !== 422) {
          state.isFailed = true;
        }
      });
  },
});

export const {
  updateForm,
  resetHelpRequest,
  updateTopic,
  resetHelpRequestStatusModal,
  checkValidationBeforeSubmit,
  validationResult,
  resetValidation,
  resetError,
  submitAllowed,
  validatePass,
  resetSubmitOnError,
} = helpRequestSlice.actions;

export default helpRequestSlice.reducer;
